(function () {
  const root = document.querySelector("[data-fm-v2-pdp]");
  if (!root) return;

  const form = root.querySelector("#fm-v2-product-form");
  const variantInput = root.querySelector("#fm-v2-variant-id");
  const qtyInput = root.querySelector("#fm-v2-qty-input");
  const mainImg = root.querySelector("[data-fm-main-img]");
  const thumbs = root.querySelectorAll("[data-fm-thumb]");
  const rows = root.querySelectorAll("[data-fm-variant-row]");
  const diameterSelect = root.querySelector("[data-fm-diameter]");
  const btnMinus = root.querySelector("[data-fm-qty-minus]");
  const btnPlus = root.querySelector("[data-fm-qty-plus]");
  const btnBuyNow = root.querySelector("[data-fm-buy-now]");
  const submitBtns = root.querySelectorAll(".fm-v2-btn--primary, .fm-v2-btn--secondary");
  const fallbackId = root.getAttribute("data-fm-fallback-id") || ""; // variante padrão p/ "prosseguir mesmo assim"

  /* ---- Product gallery carousel (auto-rotate + arrows) ---- */
  var galleryIndex = 0;
  var galleryTimer = null;
  var gallery = root.querySelector("[data-fm-gallery]");
  var galleryPrev = root.querySelector("[data-fm-gallery-prev]");
  var galleryNext = root.querySelector("[data-fm-gallery-next]");

  function showGalleryAt(i) {
    if (!thumbs.length || !mainImg) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    galleryIndex = i;
    var btn = thumbs[i];
    var url = btn.getAttribute("data-full-src");
    if (url) {
      mainImg.src = url;
      mainImg.srcset = "";
      var alt = btn.getAttribute("data-full-alt");
      if (alt) mainImg.alt = alt;
    }
    thumbs.forEach(function (t, idx) {
      t.classList.toggle("is-active", idx === i);
    });
  }

  function startGalleryAutoplay() {
    if (thumbs.length < 2) return;
    stopGalleryAutoplay();
    galleryTimer = setInterval(function () {
      showGalleryAt(galleryIndex + 1);
    }, 5000);
  }
  function stopGalleryAutoplay() {
    if (galleryTimer) { clearInterval(galleryTimer); galleryTimer = null; }
  }

  thumbs.forEach(function (btn, idx) {
    btn.addEventListener("click", function () {
      stopGalleryAutoplay();
      showGalleryAt(idx);
      startGalleryAutoplay();
    });
  });

  if (galleryPrev) galleryPrev.addEventListener("click", function () {
    stopGalleryAutoplay();
    showGalleryAt(galleryIndex - 1);
    startGalleryAutoplay();
  });
  if (galleryNext) galleryNext.addEventListener("click", function () {
    stopGalleryAutoplay();
    showGalleryAt(galleryIndex + 1);
    startGalleryAutoplay();
  });

  if (gallery && thumbs.length > 1) {
    gallery.addEventListener("mouseenter", stopGalleryAutoplay);
    gallery.addEventListener("mouseleave", startGalleryAutoplay);
    showGalleryAt(0);
    startGalleryAutoplay();
  }

function preselect1200() {
    var visibleRows = Array.prototype.filter.call(rows, function (r) {
      return !r.hidden && r.getAttribute("data-available") === "true";
    });
    if (!visibleRows.length) return;

    // procura a metragem que contém "1200" (option2 ou option1)
    var target = visibleRows.filter(function (r) {
      var meters = r.getAttribute("data-option2") || r.getAttribute("data-option1") || "";
      return meters.replace(/\s+/g, "").indexOf("1200") !== -1;
    })[0];

    if (target) selectRow(target);
  }



  function setButtonsAvailable(on) {
    // Botão de compra sempre clicável; o aviso de bitola cuida da validação.
    submitBtns.forEach(function (b) {
      b.disabled = false;
    });
  }

  function selectRow(row) {
    rows.forEach(function (r) {
      r.classList.toggle("is-selected", r === row);
      r.setAttribute("aria-selected", r === row ? "true" : "false");
    });
    if (!row) return;
    var id = row.getAttribute("data-variant-id");
    if (id && variantInput) variantInput.value = id;
    setButtonsAvailable(row.getAttribute("data-available") === "true");
  }

  function firstDiameterValue() {
    var fallback = "";
    for (var i = 0; i < rows.length; i++) {
      var o = rows[i].getAttribute("data-option1");
      if (!o) continue;
      if (!fallback) fallback = o;
      if (rows[i].getAttribute("data-available") === "true") return o;
    }
    return fallback;
  }

  function applyDiameterFilter(diameter) {
    var hasDia = !!diameter; // "" = placeholder (bitola não escolhida)
    // Sem bitola: mostra as metragens do 1º diâmetro como preview (não esconde nada, nada selecionado).
    var showDia = hasDia ? diameter : firstDiameterValue();
    rows.forEach(function (row) {
      var opt1 = row.getAttribute("data-option1");
      row.hidden = opt1 !== showDia;
    });
    /* limpa qualquer seleção anterior — usuário precisa escolher a metragem */
    rows.forEach(function (r) {
      r.classList.remove("is-selected");
      r.setAttribute("aria-selected", "false");
    });
    if (variantInput) variantInput.value = "";
    setButtonsAvailable(false);
    if (hasDia) preselect1200(); // só pré-seleciona a metragem depois de escolher a bitola
  }

  function updatePlaceholderStyle() {
    // centraliza o texto do select só enquanto o placeholder está ativo (valores reais ficam à esquerda)
    if (diameterSelect) diameterSelect.classList.toggle("fm-v2-select--placeholder", !diameterSelect.value);
  }

  if (diameterSelect) {
    updatePlaceholderStyle();
    diameterSelect.addEventListener("change", function () {
      updatePlaceholderStyle();
      applyDiameterFilter(diameterSelect.value);
    });
    applyDiameterFilter(diameterSelect.value);
  }

  rows.forEach(function (row) {
    row.addEventListener("click", function () {
      if (row.hidden || row.disabled) return;
      selectRow(row);
    });
  });

  function clampQty(n) {
    n = parseInt(String(n), 10);
    if (isNaN(n) || n < 1) n = 1;
    return n;
  }

  if (btnMinus && qtyInput) {
    btnMinus.addEventListener("click", function () {
      qtyInput.value = clampQty(Number(qtyInput.value) - 1);
    });
  }
  if (btnPlus && qtyInput) {
    btnPlus.addEventListener("click", function () {
      qtyInput.value = clampQty(Number(qtyInput.value) + 1);
    });
  }

  /* ---- Smooth exclusive accordion ---- */
  function accordionOpen(detail) {
    var body = detail.querySelector(".fm-v2-details__body");
    if (!body) { detail.open = true; return; }
    detail.open = true;
    var targetH = body.scrollHeight;
    body.style.overflow = "hidden";
    body.style.height = "0px";
    body.style.marginTop = "0px";
    body.style.opacity = "0";
    body.getBoundingClientRect();
    body.style.transition = "height .32s ease, margin-top .32s ease, opacity .24s ease";
    body.style.height = targetH + "px";
    body.style.marginTop = "6px";
    body.style.opacity = "1";
    body.addEventListener("transitionend", function fn(e) {
      if (e.propertyName !== "height") return;
      body.removeEventListener("transitionend", fn);
      body.style.cssText = "";
    });
  }

  function accordionClose(detail) {
    var body = detail.querySelector(".fm-v2-details__body");
    if (!body) { detail.open = false; return; }
    var currentH = body.getBoundingClientRect().height;
    body.style.overflow = "hidden";
    body.style.height = currentH + "px";
    body.style.marginTop = "6px";
    body.style.opacity = "1";
    body.getBoundingClientRect();
    body.style.transition = "height .32s ease, margin-top .32s ease, opacity .24s ease";
    body.style.height = "0px";
    body.style.marginTop = "0px";
    body.style.opacity = "0";
    body.addEventListener("transitionend", function fn(e) {
      if (e.propertyName !== "height") return;
      body.removeEventListener("transitionend", fn);
      detail.open = false;
      body.style.cssText = "";
    });
  }

  root.querySelectorAll(".fm-v2-details-group").forEach(function (group) {
    var items = Array.from(group.querySelectorAll(":scope > details.fm-v2-details"));
    items.forEach(function (detail) {
      var summary = detail.querySelector("summary");
      if (!summary) return;
      summary.addEventListener("click", function (e) {
        e.preventDefault();
        var wasOpen = detail.open;
        items.forEach(function (d) { if (d.open) accordionClose(d); });
        if (!wasOpen) accordionOpen(detail);
      });
    });
  });

  /* ---- Video thumb sound toggle ---- */
  var svgMuted = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var svgUnmuted = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';

  root.querySelectorAll(".fm-v2-video-thumb").forEach(function (thumb) {
    var video = thumb.querySelector("video");
    if (!video) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "fm-v2-video-thumb__sound";
    btn.setAttribute("aria-label", "Ativar som");
    btn.innerHTML = svgMuted;
    thumb.appendChild(btn);

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var unmuting = video.muted;
      /* mute todos os outros vídeos primeiro */
      root.querySelectorAll(".fm-v2-video-thumb video").forEach(function (v) { v.muted = true; });
      root.querySelectorAll(".fm-v2-video-thumb__sound").forEach(function (b) {
        b.innerHTML = svgMuted;
        b.classList.remove("is-unmuted");
        b.setAttribute("aria-label", "Ativar som");
      });
      if (unmuting) {
        video.currentTime = 0;
        video.muted = false;
        btn.innerHTML = svgUnmuted;
        btn.classList.add("is-unmuted");
        btn.setAttribute("aria-label", "Silenciar");
      }
    });
  });

  /* ---- YouTube video hero ---- */
  function parseYouTubeId(url) {
    if (!url) return null;
    var m = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  root.querySelectorAll("[data-fm-video-hero]").forEach(function (hero) {
    var btn = hero.querySelector(".fm-v2-play");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var id = parseYouTubeId(hero.getAttribute("data-fm-video-hero"));
      if (!id) return;
      var iframe = document.createElement("iframe");
      iframe.src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&playsinline=1&color=white";
      iframe.allow = "autoplay; fullscreen; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.style.cssText = "position:absolute;inset:0;width:100%;height:100%;border:0;";
      var img = hero.querySelector("img");
      if (img) img.hidden = true;
      btn.hidden = true;
      hero.appendChild(iframe);
    });
  });

  /* ---- Generic carousel (data-fm-carousel="N") ---- */
  root.querySelectorAll("[data-fm-carousel]").forEach(function (carousel) {
    var track   = carousel.querySelector("[data-fm-carousel-track]");
    var prevBtn = carousel.querySelector("[data-fm-carousel-prev]");
    var nextBtn = carousel.querySelector("[data-fm-carousel-next]");
    if (!track || !prevBtn || !nextBtn) return;
    var items = Array.from(track.children);
    if (!items.length) return;
    var current = 0;
    var desktopPer = parseInt(carousel.getAttribute("data-fm-carousel"), 10) || 3;

    function perPage() { return window.innerWidth >= 990 ? desktopPer : 1; }
    function maxIdx()  { return Math.max(0, items.length - perPage()); }

    function stride() {
      if (items.length > 1) {
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      }
      return items[0].getBoundingClientRect().width;
    }

    function goTo(n) {
      current = Math.max(0, Math.min(n, maxIdx()));
      track.style.transform = "translateX(" + (-current * stride()) + "px)";
      var max = maxIdx();
      prevBtn.hidden = nextBtn.hidden = max === 0;
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= max;
    }

    prevBtn.addEventListener("click", function () { goTo(current - 1); });
    nextBtn.addEventListener("click", function () { goTo(current + 1); });

    var rTimer;
    window.addEventListener("resize", function () {
      clearTimeout(rTimer);
      rTimer = setTimeout(function () { goTo(Math.min(current, maxIdx())); }, 100);
    });

    goTo(0);
  });

  /* ---- Tenta abrir o mini cart do tema ---- */
  function openMiniCart() {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") { drawer.open(); return true; }
    var notification = document.querySelector("cart-notification");
    if (notification && typeof notification.open === "function") { notification.open(); return true; }
    var trigger = document.querySelector(
      "[data-cart-drawer-toggle], [aria-controls='cart-drawer'], .js-drawer-open-cart, " +
      ".cart-link, .header__icon--cart, .site-header__cart, [href='#cart-drawer']"
    );
    if (trigger) { trigger.click(); return true; }
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:added", { bubbles: true }));
    return false;
  }

  /* ---- Injeta HTML de seções devolvidas pelo Section Rendering API ---- */
  function injectSection(sectionId, html) {
    if (!html) return false;
    var wrapper = document.getElementById("shopify-section-" + sectionId);
    if (wrapper) {
      var p1 = new DOMParser().parseFromString(html, "text/html");
      var newWrap = p1.getElementById("shopify-section-" + sectionId);
      wrapper.innerHTML = newWrap ? newWrap.innerHTML : html;
      return true;
    }
    var selectors = [sectionId, "#" + sectionId, "[data-section-id='" + sectionId + "']"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var p2 = new DOMParser().parseFromString(html, "text/html");
        var fresh = p2.querySelector(selectors[i]);
        el.innerHTML = fresh ? fresh.innerHTML : html;
        return true;
      }
    }
    return false;
  }

  /* ---- Abre o drawer se sessionStorage indicou (pós-reload) ---- */
  try {
    if (sessionStorage.getItem("fm_open_cart") === "1") {
      sessionStorage.removeItem("fm_open_cart");
      setTimeout(openMiniCart, 250);
    }
  } catch (e) {}

  /* ---- Aviso: bitola (diâmetro) não selecionada ---- */
  function needsBitola() {
    return !!diameterSelect && !diameterSelect.value;
  }

  var gateModal = null;
  var gateProceedFn = null;
  function buildGate() {
    gateModal = document.createElement("div");
    gateModal.className = "fm-v2-bitola-modal";
    gateModal.setAttribute("role", "dialog");
    gateModal.setAttribute("aria-modal", "true");
    gateModal.innerHTML =
      '<div class="fm-v2-bitola-modal__box">' +
      '<p class="fm-v2-bitola-modal__text">Atenção: você não selecionou o diâmetro da bitola. Deseja prosseguir?</p>' +
      '<div class="fm-v2-bitola-modal__buttons">' +
      '<button type="button" class="fm-v2-bitola-modal__btn fm-v2-bitola-modal__btn--proceed">Prosseguir mesmo assim</button>' +
      '<button type="button" class="fm-v2-bitola-modal__btn fm-v2-bitola-modal__btn--back">Voltar e escolher</button>' +
      '</div></div>';
    document.body.appendChild(gateModal);
    gateModal.querySelector(".fm-v2-bitola-modal__btn--back").addEventListener("click", onGateBack);
    gateModal.querySelector(".fm-v2-bitola-modal__btn--proceed").addEventListener("click", onGateProceed);
    gateModal.addEventListener("click", function (e) { if (e.target === gateModal) closeGate(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && gateModal.classList.contains("is-open")) closeGate();
    });
  }
  function openGate(onProceed) {
    gateProceedFn = onProceed;
    if (!gateModal) buildGate();
    gateModal.classList.add("is-open");
    var back = gateModal.querySelector(".fm-v2-bitola-modal__btn--back");
    if (back) back.focus();
  }
  function closeGate() { if (gateModal) gateModal.classList.remove("is-open"); }
  function onGateBack() {
    closeGate();
    gateProceedFn = null;
    if (diameterSelect) {
      try { diameterSelect.focus(); } catch (e) {}
      if (diameterSelect.scrollIntoView) diameterSelect.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  function onGateProceed() {
    closeGate();
    var fn = gateProceedFn; gateProceedFn = null;
    if (fn) fn();
  }

  /* ---- Adicionar ao carrinho: abre mini cart ---- */
  function doAdd(id) {
    var q = clampQty(qtyInput.value);
    var submitBtn = form.querySelector("button[type='submit']");
    if (submitBtn) submitBtn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{ id: id, quantity: q }],
        sections: "cart-drawer,cart-icon-bubble,cart-notification",
        sections_url: window.location.pathname
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        return res.json();
      })
      .then(function (data) {
        if (submitBtn) submitBtn.disabled = false;
        var refreshed = false;
        if (data && data.sections) {
          Object.keys(data.sections).forEach(function (id) {
            if (injectSection(id, data.sections[id])) refreshed = true;
          });
        }
        if (refreshed) {
          openMiniCart();
        } else {
          /* Section Rendering API não funcionou pra esse tema → recarrega a página */
          try { sessionStorage.setItem("fm_open_cart", "1"); } catch (e) {}
          window.location.reload();
        }
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  if (form && variantInput && qtyInput) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (needsBitola()) {
        openGate(function () {
          var fid = parseInt(String(fallbackId), 10);
          if (fid) { variantInput.value = fallbackId; doAdd(fid); }
        });
        return;
      }
      var id = parseInt(String(variantInput.value), 10);
      if (!id) return; // bitola escolhida mas metragem não (raro) → não faz nada
      doAdd(id);
    });
  }

  /* ---- Finalizar compra: vai direto para checkout ---- */
  function doBuyNow(id) {
    var q = clampQty(qtyInput.value);
    btnBuyNow.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        window.location.href = "/checkout";
      })
      .catch(function () {
        btnBuyNow.disabled = false;
      });
  }

  if (btnBuyNow && variantInput && qtyInput) {
    btnBuyNow.addEventListener("click", function (e) {
      e.preventDefault();
      if (needsBitola()) {
        openGate(function () {
          var fid = parseInt(String(fallbackId), 10);
          if (fid) { variantInput.value = fallbackId; doBuyNow(fid); }
        });
        return;
      }
      var id = parseInt(String(variantInput.value), 10);
      if (!id) return;
      doBuyNow(id);
    });
  }
})();
